import { INJECT_ELEMENT_CLASS, PRODUCT_ELEMENT } from "@/constants/selectors";

import Minilog from "minilog";
import { debounce } from "@/utils/debounce";
import { injectInModal } from "@/utils/injectInModal";
import { injectRatingsInProuctCard } from "@/utils/injectRatingsInProductCards";
import { loadRatings } from "@/utils/loadRatings";

// eslint-disable-next-line new-cap
const logger = Minilog("778");
Minilog.enable();

export async function initBlock778() {
  logger.info("initBlock778 start");

  // 1. Функция получает массив блоков своего типа

  const blocksJqElements = $('[data-record-type="778"]');

  // 3. Встраивание компонентов плагина

  blocksJqElements.each((_, blockElement) => {
    const blockJqElement = $(blockElement);

    injectRatingsInProuctCard(blockJqElement.find(PRODUCT_ELEMENT), logger);

    // 4. Обработка событий
    blockElement.addEventListener(
      "DOMNodeInserted",
      debounce((event) => {
        // @ts-ignore
        const insertedElement = event.relatedNode;

        if (insertedElement.className.indexOf("CC") >= 0) return;

        logger.info("inject elements start");

        // Подгружаю новые данные
        loadRatings(blockJqElement.find(PRODUCT_ELEMENT), logger);

        // Удаляю все лишнее
        blockJqElement.find(`.${INJECT_ELEMENT_CLASS}`).remove();

        // Работа с перерисовкой модалки
        const modalJqElement = blockJqElement.find(".t-popup");
        injectInModal(modalJqElement, logger);

        // Работа с перерисовкой товаров в каталоге
        injectRatingsInProuctCard(blockJqElement.find(PRODUCT_ELEMENT), logger);

        logger.info("inject elements finish");
      }, 50)
    );
  });

  logger.info("initBlock778 finish");
}
